import { useEffect } from 'react'

// Centered modal dialog with rounded corners, drop shadow and a frosted-glass
// (backdrop-blur) overlay.
export default function Modal({ open, onClose, title, subtitle, t, width = 480, children }) {
  useEffect(() => {
    function onEsc(e) { if (e.key === 'Escape') onClose && onClose() }
    if (open) document.addEventListener('keydown', onEsc)
    return () => document.removeEventListener('keydown', onEsc)
  }, [open, onClose])

  if (!open) return null

  return (
    <div className="eh-overlay" onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.35)', backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div className="eh-modal" onClick={(e) => e.stopPropagation()}
        style={{ width, maxWidth: '94vw', maxHeight: '90vh', overflowY: 'auto', background: t.card, borderRadius: 18, boxShadow: '0 24px 60px rgba(0,0,0,0.30)', border: `1px solid ${t.cardBorder}` }}>
        {title && (
          <div style={{ padding: '1.1rem 1.4rem', borderBottom: `1px solid ${t.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, position: 'sticky', top: 0, background: t.card, borderRadius: '18px 18px 0 0' }}>
            <div>
              <div style={{ fontSize: 17, fontWeight: 800, color: t.text }}>{title}</div>
              {subtitle && <div style={{ fontSize: 12, color: t.textMuted, marginTop: 2 }}>{subtitle}</div>}
            </div>
            <button onClick={onClose} aria-label="Close"
              style={{ background: t.input, border: `1px solid ${t.border}`, borderRadius: 8, width: 30, height: 30, cursor: 'pointer', color: t.textSub, fontSize: 15, flexShrink: 0 }}>✕</button>
          </div>
        )}
        <div style={{ padding: '1.4rem' }}>{children}</div>
      </div>
    </div>
  )
}
